import React, { useContext } from "react";
import { ContextProvider } from "../providers/app.provider";
import { Header } from "semantic-ui-react";

const Guard = ({ children }) => {
  const {
    userDetails: { sfdcId },
  } = useContext(ContextProvider);

  return (
    <div>
      {sfdcId.length === 0 ? (
        <Header size="medium">
          *Please enter the Salesforce Opportunity ID to proceed
        </Header>
      ) : (
        children
      )}
      {/* {(children)} */}
    </div>
  );
};

export default Guard;
